/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Training_InstructionsInputs */

const en_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Training Instructions`)
};

const es_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones de entrenamiento personalizadas`)
};

const fr_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions d'entraînement personnalisées`)
};

const de_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Trainingsanweisungen`)
};

const ja_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムトレーニングの指示`)
};

const zh_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义训练指令`)
};

const ar_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليمات تدريب مخصصة`)
};

const id_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruksi Pelatihan Kustom`)
};

const it_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzioni di Addestramento Personalizzate`)
};

const ru_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские инструкции для обучения`)
};

const pt_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções de Treinamento Personalizadas`)
};

const ko_custom_training_instructions = /** @type {(inputs: Custom_Training_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤형 학습 지침`)
};

/**
* | output |
* | --- |
* | "Custom Training Instructions" |
*
* @param {Custom_Training_InstructionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const custom_training_instructions = /** @type {((inputs?: Custom_Training_InstructionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Training_InstructionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_custom_training_instructions(inputs)
	if (locale === "es") return es_custom_training_instructions(inputs)
	if (locale === "fr") return fr_custom_training_instructions(inputs)
	if (locale === "de") return de_custom_training_instructions(inputs)
	if (locale === "ja") return ja_custom_training_instructions(inputs)
	if (locale === "zh") return zh_custom_training_instructions(inputs)
	if (locale === "ar") return ar_custom_training_instructions(inputs)
	if (locale === "id") return id_custom_training_instructions(inputs)
	if (locale === "it") return it_custom_training_instructions(inputs)
	if (locale === "ru") return ru_custom_training_instructions(inputs)
	if (locale === "pt") return pt_custom_training_instructions(inputs)
	return ko_custom_training_instructions(inputs)
});